import { Button, Form } from "antd";
import { FormInstance } from "antd/es/form";
import { TableIssueAuthenType } from "../../entity/Entity";
import { normalizeName, RowValues, validateRowCCUS062 } from "../../validation";

type SelectedRow = Pick<TableIssueAuthenType, "key" | "fullName">;

export const canSubmitAuthentication = (
  selectedRows: SelectedRow[],
  getRowValue: (key: string) => RowValues | undefined
): boolean =>
  selectedRows.length > 0 &&
  selectedRows.every((record) => {
    const row = getRowValue(record.key);
    return (
      !!row &&
      !!normalizeName(record.fullName) &&
      Object.keys(validateRowCCUS062(row, record.fullName)).length === 0
    );
  });

export const AuthenticationSubmitButton = ({
  form,
  selectedRows,
}: {
  form: FormInstance;
  selectedRows: SelectedRow[];
}) => (
  <Form.Item noStyle shouldUpdate>
    {() => (
      <Button
        htmlType="submit"
        size="large"
        className="button-purple btn-submit-ccus062 cm047-btn-submit cm024-btn-submit"
        type="primary"
        disabled={
          !canSubmitAuthentication(selectedRows, (key) =>
            form.getFieldValue(`record${key}`)
          )
        }
      >
        認証実行
      </Button>
    )}
  </Form.Item>
);
